
export const BUSINESS_RULES = {
    // Timeout de sessão da tela de reserva/pagamento, em minutos.
    timeoutMinutes: 30,

    // FERIADOS REMOVIDOS em 2026-08-14.
    //
    // A lista existia para o cálculo de dias úteis do prazo de cancelamento. Esse cálculo saiu do
    // frontend quando o espelho da política foi apagado (13/08) — a regra passou a morar só no
    // backend, que tem o próprio calendário. Sem consumidor, a lista era dado duplicado esperando
    // divergir: bastava um feriado novo entrar de um lado e não do outro, e nada acusaria.
    //
    // Se algum dia o frontend precisar de dias úteis de novo, NÃO recriar a lista aqui: o backend
    // publica em POST /api/v1/app/business-calendar, com "anosCobertos" — que existe para dar para
    // perceber quando ela envelhecer, porque sem o ano corrente o cálculo de dias úteis passa a
    // ignorar feriados EM SILÊNCIO.
};

export const UI_SETTINGS = {
    theme: 'dark',
    language: 'pt-BR',
    dateFormat: 'DD/MM/YYYY'
};

// ----------------------------------------------------------------------------
// FEATURE FLAGS
// ----------------------------------------------------------------------------
// Constantes de controle de funcionalidades. Para rollback rápido sem precisar
// reverter versionamento, basta mudar o valor aqui + rebuild + redeploy.
//
// Convenção: prefixo SHOW_/ENABLE_/USE_ para indicar boolean toggles.
export const FEATURE_FLAGS = {
    // Mostra BRL como valor primário (cor de destaque + fonte maior) e USD como
    // referência menor abaixo, nas telas de busca/booking. Quando false, volta
    // ao comportamento anterior (USD principal, ou BRL quando destino é Brasil).
    // Não afeta a tela de pagamento (hotelBookingPayment), que mantém moeda
    // original + BRL no momento do pagamento (lógica própria).
    SHOW_BRL_AS_PRIMARY: true,

    // Cancela requests obsoletos via AbortController quando o componente
    // desmonta ou o usuário dispara nova ação (ex.: troca rápida entre telas
    // admin, mudança de filtros na busca). Quando false, as actions ignoram
    // o signal e o comportamento volta ao anterior (request continua até
    // resposta, mesmo após navegação).
    //
    // Coordenado com Tier 1 backend (TD-049..066 do repo da API) + TD-064
    // futuro (req.on('close') no backend). Frontend pode operar isoladamente:
    // sem TD-064 backend, o pool não libera mais rápido, mas a UX já melhora
    // (sem race condition, sem warning de setState em componente desmontado).
    ENABLE_REQUEST_CANCELLATION: true,

    // Mobile revamp — sub-flags por fase. Quando uma sub-flag está true E o
    // viewport está em mobile (useResponsive isMobile), a Screen
    // correspondente ganha a className `mobile-revamp` no root e o CSS
    // responsivo scoped por essa classe ativa. Quando false: a Screen
    // segue renderizando o CSS desktop atual em qualquer viewport (mal
    // escalado em mobile mas funcional como hoje).
    //
    // Rollback granular: flipar qualquer uma para false reverte só aquela
    // área, sem afetar as outras fases.
    //
    // Origem: plano `.context/plans/2026-06-09-mobile-revamp-execution.md`,
    // Fase 0. As fases 1-5 ativam cada uma destas conforme entregues.
    MOBILE_REVAMP: {
        HOME:    true,   // Fase 1 — Home + onboarding (Home/Main, RegisterModal, ForgotPassword, PasswordSetup)
        SEARCH:  true,   // Fase 2 — Busca pública (Order/Main, hotelSearchResult)
        DETAILS: true,   // Fase 3 — Detalhe + booking (hotelDetails, hotelBooking, hotelBookingConfirm)
        PAYMENT: false,   // Fase 4 — Pagamento (hotelBookingPayment) — financeiro, validar com cartão real em staging antes do flip
        ADMIN:   false,   // Fase 5 — Admin (todas as telas + modais)
    },

    // Cotação Fase 2 — funil semi-automático com autosserviço do cliente
    // (página pública /cotacao/:token de seleção+aprovação, status novos,
    // passo "prosseguir com reserva").
    //
    // ATENÇÃO ANTES DE SUBIR (corrigido em 2026-08-19): esta flag já está LIGADA e
    // `F2_BACKEND_READY = true` em Store/Actions/Quote.js — não é mais mock, os thunks chamam
    // /api/v1/quote/* de verdade. O texto que estava aqui ("TODO em MOCK, manter OFF em prod")
    // ficou desatualizado quando o backend entregou os endpoints, e quem o lesse na véspera de um
    // deploy tomaria a decisão errada nos dois sentidos.
    //
    // Consequência: subir para produção LIGA a Cotação Fase 2 junto. Confirmar que os endpoints
    // Fase 2 estão em produção antes da cascata — ou virar esta flag para false e soltar a Cotação
    // numa release própria.
    // Spec: .context/specs/cotacao-fase2-funil-cliente.md
    COTACAO_FASE2: true,
};

